import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { isRateLimited } from '../lib/rpcError'
import { WAITLIST_COPY, isEmailLike, type WaitlistLang } from '../lib/waitlist'

export type WaitlistState = 'idle' | 'sending' | 'done' | 'invalid' | 'busy' | 'failed'

/** Joins the waitlist through join_waitlist() (040), the only way in for a signed-out visitor. */
export function useWaitlist(lang: WaitlistLang) {
  const [state, setState] = useState<WaitlistState>('idle')

  async function join(email: string) {
    if (!isEmailLike(email)) { setState('invalid'); return }
    setState('sending')
    const { error, status } = await supabase.rpc('join_waitlist', {
      p_email: email.trim(), p_lang: lang, p_consent: WAITLIST_COPY[lang].consent,
    })
    if (!error) setState('done')
    else if (isRateLimited(error, status)) setState('busy')
    else if (error.code === '22023') setState('invalid')
    else setState('failed')
  }

  return { state, join, reset: () => setState('idle') }
}
